/**
 * @generated SignedSource<<6048f438135c31bd993f1e6138cad0b3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserGroupMembersInput = {
  add?: ReadonlyArray<any> | null | undefined;
  groupUUID: any;
  remove?: ReadonlyArray<any> | null | undefined;
};
export type UpdateUserGroupMembersMutation$variables = {
  input: UpdateUserGroupMembersInput;
};
export type UpdateUserGroupMembersMutation$data = {
  readonly updateUserGroupMembers: {
    readonly problems: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly userGroup: {
      readonly id: string;
    } | null | undefined;
  };
};
export type UpdateUserGroupMembersMutation = {
  response: UpdateUserGroupMembersMutation$data;
  variables: UpdateUserGroupMembersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UserGroup",
  "kind": "LinkedField",
  "name": "userGroup",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUserGroupMembersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserGroupMembersPayload",
        "kind": "LinkedField",
        "name": "updateUserGroupMembers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpdateUserGroupMembersMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateUserGroupMembersPayload",
        "kind": "LinkedField",
        "name": "updateUserGroupMembers",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "problems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v3/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "248b79da284502a030aef8aee128cd1e",
    "id": null,
    "metadata": {},
    "name": "UpdateUserGroupMembersMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateUserGroupMembersMutation(\n  $input: UpdateUserGroupMembersInput!\n) {\n  updateUserGroupMembers(input: $input) {\n    problems {\n      __typename\n      message\n    }\n    userGroup {\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "42c3caa28849839b37a5b45c92b4157e";

export default node;
